import { Box, Typography } from '@mui/material';
import Iconify from './Iconify';
import '../css/nullDataBox.css';

const NullDataBox = ({ setOpenDialog, description, buttonTitle }) => {

    return (
        <Box className="nullDataBox_main_box" onClick={() => setOpenDialog(true)}>
            <Typography className='nullDataBox_Description'>{description}</Typography>
            <Box className='nullDataBox_action_box'>
                <Iconify icon='material-symbols-light:add' className='nullDataBox_action_icon' />
                <Typography className='nullDataBox_action_title'>{buttonTitle}</Typography>
            </Box>
        </Box>
    )
}

export default NullDataBox